<template>
  <v-dialog :value="value" max-width="640" @input="$emit('input', $event)">
    <v-card>
      <v-toolbar color="primary" dark flat dense>
        <v-toolbar-title>{{
          $t("reports.aiCredit.addInstantTitle")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <h3 class="black--text mb-1">
          {{ $t("reports.aiCredit.addInstantTitle") }}
        </h3>
        <p class="grey--text mb-4">
          {{ $t("reports.aiCredit.addInstantDesc") }}
        </p>

        <v-row class="mb-2">
          <v-col cols="12" md="6">
            <div class="grey--text text-caption">
              {{ $t("reports.aiCredit.colCooperative") }}
            </div>
            <div class="font-weight-bold">{{ coopName }}</div>
          </v-col>
        </v-row>

        <v-divider class="mb-4" />

        <label class="d-block mb-1 black--text">{{
          $t("reports.aiCredit.addCredits")
        }}</label>
        <v-text-field
          v-model.number="amount"
          type="number"
          min="1"
          :suffix="$t('reports.aiCredit.credits')"
          placeholder="2000"
          outlined
          dense
          hide-details
        />
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-spacer />
        <v-btn outlined color="primary" @click="close">{{
          $t("reports.aiCredit.cancel")
        }}</v-btn>
        <v-btn
          color="primary"
          depressed
          :disabled="!valid"
          :loading="saving"
          @click="submit"
        >
          {{ $t("reports.aiCredit.submit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AiCreditService from "@/_services/AiCreditService";

export default {
  name: "AddInstantCreditsDialog",
  props: {
    value: { type: Boolean, default: false },
    cooperative: { type: Object, default: null },
  },
  data() {
    return { amount: null, saving: false };
  },
  computed: {
    coopName() {
      return this.cooperative ? this.cooperative.cooperative : "";
    },
    valid() {
      return this.cooperative && Number(this.amount) > 0;
    },
  },
  watch: {
    value(open) {
      if (open) this.amount = null;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    async submit() {
      if (!this.valid) return;
      this.saving = true;
      try {
        const data = await AiCreditService.topUp(
          this.cooperative.organization,
          {
            amount: Number(this.amount),
          }
        );
        if (data && data.success === false) throw new Error(data.message);
        this.$emit("saved");
      } catch (e) {
        this.$notify({
          title: this.$t("reports.aiCredit.errorTitle"),
          text: this.$t("reports.aiCredit.saveFailed"),
          type: "error",
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
